export const THEMES = {
  DARK: "dark",
  LIGHT: "light",
};
